var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "zoom"
  }, [_c("div", {
    staticClass: "scale"
  }, [_c("span", {
    staticClass: "scaleContent"
  }, [_c("span", {
    staticClass: "minus",
    attrs: {
      slot: "addonBefore"
    },
    on: {
      click: function click($event) {
        return _vm.$store.dispatch("designCategory/set_scale_minus");
      }
    },
    slot: "addonBefore"
  }, [_vm._v("-")]), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.scale,
      expression: "scale"
    }],
    attrs: {
      id: "scaleInput",
      autocomplete: "off"
    },
    domProps: {
      value: _vm.scale
    },
    on: {
      change: _vm.handleChange,
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.scale = $event.target.value;
      }
    }
  }), _c("span", {
    attrs: {
      slot: "suffix"
    },
    slot: "suffix"
  }, [_vm._v("%")]), _c("span", {
    staticClass: "plus",
    attrs: {
      slot: "addonAfter"
    },
    on: {
      click: function click($event) {
        return _vm.$store.dispatch("designCategory/set_scale_plus");
      }
    },
    slot: "addonAfter"
  }, [_vm._v("+")])])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };